import { CURRENT_CLIENT } from '@/constants/index'

export type LoginByCodeConfig = {
  enabled?: boolean
  label?: string
}

export function getLoginByCodeConfig(): LoginByCodeConfig {
  const auth = (CURRENT_CLIENT as { auth?: { loginByCode?: LoginByCodeConfig } }).auth
  return (auth?.loginByCode ?? {}) as LoginByCodeConfig
}

export function loginByCodeEnabled(): boolean {
  return Boolean(getLoginByCodeConfig().enabled)
}

export function loginByCodeLabel(): string {
  return getLoginByCodeConfig().label ?? 'Email me a sign-in code'
}
